import { render } from "./TextCleaning.vue?vue&type=template&id=266c0268"
import script from "./TextCleaning.vue?vue&type=script&lang=js"
export * from "./TextCleaning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__